import * as React from "react";
import "../../css/Weather.css";
import Clock from "./Clock";
import * as WeatherUtils from "../../utils/WeatherUtils";
import { connect } from "react-redux";
import * as MyTypes from "MyTypes";
import Geosuggest, { Suggest } from "react-geosuggest";
import "../../geosuggest.css";
import { Dispatch } from "redux";
import { actionTypes } from "../../redux/actions";
import Spinner from "../common/Spinner";

interface IState {
  city: string;
  temp: number;
  minTemp: number;
  maxTemp: number;
  description: string;
  country: string;
  sunrise: number;
  sunset: number;
  feelslike: number;
  humidity: number;
  wind: number;
  windDirection: string;
  fMetric: boolean;
  value: boolean;
  clouds: number;
  loaded: boolean;
}

interface StoreProps {
  saveCoordinates: (lat: number, lng: number, country: string) => void;
  lat: number;
  lng: number;
  country: string;
}

class Weather extends React.Component<StoreProps, IState> {
  public state: IState = {
    city: "",
    temp: 0,
    minTemp: 0,
    maxTemp: 0,
    description: "",
    country: "",
    sunrise: 0,
    sunset: 0,
    feelslike: 0,
    humidity: 0,
    wind: 0,
    windDirection: "",
    fMetric: true,
    value: false,
    clouds: 0,
    loaded: false
  };

  componentWillMount() {
  }

  componentDidMount() {
    navigator.geolocation.getCurrentPosition(position => {
      let lat = parseFloat(position.coords.latitude.toFixed(2));
      let long = parseFloat(position.coords.longitude.toFixed(2));
      this.fetchWeatherInfo(lat, long);
      this.props.saveCoordinates(lat, long, this.state.country);
    })
    navigator.geolocation.watchPosition(position => {
    }, (error) => {
      if (error.code === error.PERMISSION_DENIED)
        this.setState({loaded: true});
        this.fetchWeatherInfo(38.91, -77.04);
        this.props.saveCoordinates(38.91, -77.04, "us");
    });

  }

  onSuggestSelect = (place: Suggest) => {
    if (place && place.location) {
      this.fetchWeatherInfo(place.location.lat, place.location.lng);
    }
  };

  fetchWeatherInfo = (lat: number,lng: number) => {
    let apiKey = "743faba233abe3f01ac122870c10e617";
    let url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lng}&units=imperial&appid=${apiKey}`;
    (async () => {
      let response = await fetch(url);
      let weather = await response.json();
      this.setState({
        loaded: true,
        city: weather.name,
        temp: Math.floor(weather.main.temp),
        minTemp: weather.main.temp_min,
        maxTemp: weather.main.temp_max,
        description: weather.weather[0].description,
        country: weather.sys.country,
        sunrise: weather.sys.sunrise,
        sunset: weather.sys.sunset,
        feelslike: weather.main.feels_like,
        humidity: weather.main.humidity,
        wind: weather.wind.speed,
        windDirection: weather.wind.deg,
        clouds: weather.clouds.all
      });
    })();
  };

  setToggle = () => {
    this.setState({ value: !this.state.value });
  };

  convertToCelsius = () => {
    this.setState({
      temp: WeatherUtils.convertToCelsius(this.state.temp),
      minTemp: WeatherUtils.convertToCelsius(this.state.minTemp),
      maxTemp: WeatherUtils.convertToCelsius(this.state.maxTemp),
      feelslike: WeatherUtils.convertToCelsius(this.state.feelslike),
      fMetric: false
    });
  };

  convertToFahrenheit = () => {
    this.setState({
      temp: WeatherUtils.convertToFahrenheit(this.state.temp),
      minTemp: WeatherUtils.convertToFahrenheit(this.state.minTemp),
      maxTemp: WeatherUtils.convertToFahrenheit(this.state.maxTemp),
      feelslike: WeatherUtils.convertToFahrenheit(this.state.feelslike),
      fMetric: true
    });
  };

  render() {
    if (this.state && !this.state.loaded) {
      return <Spinner />;
    } else {
      return (
        <div className="weather">
          <Geosuggest
            placeholder="Type your location and select!"
            initialValue={this.state.city + " " + this.state.country}
            onSuggestSelect={this.onSuggestSelect}
            location={new google.maps.LatLng(38.96, -77.39)}
            radius={20}
          />

          <div className="weatherIcon">
            <i
              className={WeatherUtils.getWeatherIcon(this.state.description)}
            ></i>
            <Clock />
            <div
              className="temperature"
              onClick={
                this.state.fMetric
                  ? this.convertToCelsius
                  : this.convertToFahrenheit
              }
            >
              <span>{this.state.temp}</span>
              {this.state.fMetric ? (
                <span className="metric">&#8457;</span>
              ) : (
                <span className="metric">&#8451;</span>
              )}
              <br />
              <span>{this.state.description}</span>
            </div>
          </div>

          <div className="sunInfo">
            <div className="sun">
              <span>
                Sun Rise: <i className="wi wi-sunrise"></i>{" "}
                {WeatherUtils.convertTime(this.state.sunrise)} AM
              </span>{" "}
              <br />
              <span>
                Sun Set: <i className="wi wi-sunset"></i>{" "}
                {WeatherUtils.convertTime(this.state.sunset)} PM
              </span>{" "}
              <br />
            </div>
            <hr />
            <div className="sun">
              <span>Humidity: {this.state.humidity} %</span> <br />
              <span>Wind: {this.state.wind + " MPH"} </span> <br />
              <span>
                Wind Direction:{" "}
                {WeatherUtils.convertWindDir(this.state.windDirection)}
              </span>
              <br />
            </div>
            <div className="sun">
              {this.state.city + " " + this.state.country}
            </div>
          </div>
          <hr />

          <div className="extraInfo">
            <div className="sun">
              <span>
                Minimun Temperature: {this.state.minTemp}
                {this.state.fMetric ? (
                  <span className="othersMetric">&#8457;</span>
                ) : (
                  <span className="othersMetric">&#8451;</span>
                )}
              </span>
            </div>
            <div className="sun">
              <span>
                Maximum Temperature: {this.state.maxTemp}
                {this.state.fMetric ? (
                  <span className="othersMetric">&#8457;</span>
                ) : (
                  <span className="othersMetric">&#8451;</span>
                )}
              </span>
            </div>
            <div className="sun">
              <span>
                Feels like: {Math.round(this.state.feelslike)}
                {this.state.fMetric ? (
                  <span className="othersMetric">&#8457;</span>
                ) : (
                  <span className="othersMetric">&#8451;</span>
                )}
              </span>
            </div>
            <hr />
            <div className="clouds">
              <span>Clouds : {this.state.clouds}%</span>
            </div>
          </div>
          <div></div>
        </div>
      );
    }
  }
}

const MapStateToProps = (store: MyTypes.ReducerState) => {
  return {
    lat: store.lat,
    lng: store.lng
  };
};

const MapDispatchToProps = (dispatch: Dispatch<MyTypes.RootAction>) => ({
  saveCoordinates: (lat: number, lng: number, country: string) =>
    dispatch({
      type: actionTypes.SAVE_COORDINATES,
      payload: { lat, lng, country }
    })
});

export default connect(
  MapStateToProps,
  MapDispatchToProps
)(Weather);
